
import { useState, useEffect } from 'react';
import { Button, Row, Col, Form} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addSubCategory } from '../../services/Configs/ItemSubCategoriesService'
 

function AddItemSubCategoryModal({ show, handleClose, handleReload, categoryId }) {

  const [formData, setFormData] = useState({
    name:'',
    categoryId
  });
  
  const handleChangeCategoryName = (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            name: value
        });
  }
  const handleAddSubCategory = () => {
    let pendingInputs = [];
    if(!formData.name)
    {
        pendingInputs.push("Nombre")
    }
    if(pendingInputs.length == 0)
    {

        addSubCategory(formData.categoryId ,formData.name).then(categoryResult => {
            toast.success('Subcategoría creada correctamente');
            handleClose();
            handleReload();
        });
    }
    else
    {
        toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }
  useEffect(() => {
    if (show) {
      setFormData({
        name:'',
        categoryId
      });
    }
  }, [show]);
  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Agregar SubCategoría</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
              <Col xl={12} className=' p-2'  >
                <Form.Label>Nombre:</Form.Label>
                          <Form.Group controlId="">
                          <Form.Control
                              type="text"
                              name="name"
                              placeholder=''
                              value={formData.name}
                              onChange={handleChangeCategoryName}
                          />
                  </Form.Group>
              </Col>
       </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleAddSubCategory}>
           Guardar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
           Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddItemSubCategoryModal;
